import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {Storage} from '@ionic/storage-angular';
import {from, map, tap} from 'rxjs';
import {RouteName} from '@ew/enums';

export enum Tutorial {
  Completed = 'ion_did_tutorial',
}

export const checkTutorialGuard = () => {
  const storage = inject(Storage);
  const router = inject(Router);

  return from(storage.get(Tutorial.Completed)).pipe(
    tap((didTutorial) => {
      if (didTutorial === true) {
        router.navigateByUrl(RouteName.Dashboard);
      }
    }),
    map((didTutorial) => !didTutorial),
  );
};
